module.exports = __webpack_public_path__ + "img/buscar.5c0566c7.svg";